import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/leadFunctions/leadRFIActions'
import * as api from '../../api/lead/rfis'

import { fetchLeadDetails } from '../leadDetails'

function* leadRFIsRefresh(action) {
  try {
    const payload = yield call(api.getLeadRFIs, action.leadId)
    yield put({ type: constants.LEAD_RFIS_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_RFIS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchLeadRFIs() {
  yield takeLatest(constants.LEAD_RFIS_REFRESH.ACTION, leadRFIsRefresh)
}

function* sagaCreateLeadRFI(action) {
  try {
    const payload = {
      rfi_data: {
        lead_id: action.leadId,
        organization_id: action.content.organization_id,
        description: action.content.description,
        attention: action.content.attention,
        created_by_id: action.userId,
        updated_by_id: action.userId
      },
      rfi_items: action.rfiItems
    }
    yield call(api.createLeadRFI, payload)
    yield put({ type: constants.LEAD_RFI_CREATE.SUCCESS, payload })
    yield call(leadRFIsRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_RFI_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateLeadRFI() {
  yield takeLatest(constants.LEAD_RFI_CREATE.ACTION, sagaCreateLeadRFI)
}

function* sagaUpdateLeadRFI(action) {
  try {
    const payload = {
      rfi_data: {
        lead_id: action.leadId,
        organization_id: action.content.organization_id,
        description: action.content.description,
        attention: action.content.attention,
        status: action.content.status,
        updated_by_id: action.userId
      },
      rfi_items: action.rfiItems,
      rfi_id: action.rfiId
    }
    yield call(api.updateLeadRFI, payload)
    yield put({ type: constants.LEAD_RFI_UPDATE.SUCCESS, payload })
    yield call(leadRFIsRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_RFI_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateLeadRFI() {
  yield takeLatest(constants.LEAD_RFI_UPDATE.ACTION, sagaUpdateLeadRFI)
}

function* sagaDeleteLeadRFI(action) {
  try {
    const payload = {
      rfiId: action.rfiId,
      leadId: action.leadId
    }
    yield call(api.deleteLeadRFI, action)
    yield put({ type: constants.LEAD_RFI_DELETE.SUCCESS, payload })
    yield call(leadRFIsRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_RFI_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteLeadRFI() {
  yield takeLatest(constants.LEAD_RFI_DELETE.ACTION, sagaDeleteLeadRFI)
}

function* getRfiItems(action) {
  try {
    const payload = yield call(api.getRFIData, action.rfiId)
    yield put({ type: constants.GET_LEAD_RFI_DATA.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_LEAD_RFI_DATA.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetRfiItems() {
  yield takeLatest(constants.GET_LEAD_RFI_DATA.ACTION, getRfiItems)
}

// ATTACHMENT SAGAS
function* uploadLeadRfiAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      leadRfiId: action.leadRfiId
    }

    yield call(api.uploadAttachments, payload)
    yield put({ type: constants.UPLOAD_LEAD_RFI_ATTACHMENT.SUCCESS, payload })
    yield call(getLeadRfiAttachments, { leadRfiId: action.leadRfiId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_LEAD_RFI_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadLeadRfiAttachments() {
  yield takeLatest(constants.UPLOAD_LEAD_RFI_ATTACHMENT.ACTION, uploadLeadRfiAttachments)
}

function* getLeadRfiAttachments(action) {
  try {
    const payload = yield call(api.getAttachments, action.leadRfiId)
    yield put({ type: constants.GET_LEAD_RFI_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_LEAD_RFI_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetLeadRfiAttachments() {
  yield takeLatest(constants.GET_LEAD_RFI_ATTACHMENTS.ACTION, getLeadRfiAttachments)
}

function* updateLeadRfiAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      user_id: action.userId,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_LEAD_RFI_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(getLeadRfiAttachments, { leadRfiId: action.currentId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_LEAD_RFI_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateLeadRfiAttachmentDescription() {
  yield takeLatest(
    constants.UPDATE_LEAD_RFI_ATTACHMENT_DESCRIPTION.ACTION,
    updateLeadRfiAttachmentDescription
  )
}

function* deleteLeadRfiAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      leadRfiId: action.currentId
    }

    yield call(api.deleteAttachment, payload)
    yield put({ type: constants.DELETE_LEAD_RFI_ATTACHMENT.SUCCESS, payload })
    yield call(getLeadRfiAttachments, { leadRfiId: action.currentId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_LEAD_RFI_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteLeadRfiAttachments() {
  yield takeLatest(constants.DELETE_LEAD_RFI_ATTACHMENT.ACTION, deleteLeadRfiAttachment)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchLeadRFIs),

    fork(watchCreateLeadRFI),
    fork(watchUpdateLeadRFI),
    fork(watchDeleteLeadRFI),

    fork(watchGetRfiItems),

    fork(watchUploadLeadRfiAttachments),
    fork(watchGetLeadRfiAttachments),
    fork(watchUpdateLeadRfiAttachmentDescription),
    fork(watchDeleteLeadRfiAttachments)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/leadFunctions/leadRFISaga.js